import React from 'react';
import Slider from 'react-slick';
import { Icon } from '@iconify/react';
import Brand from '../Brand/Brand';
import SectionHeading from '../SectionHeading/SectionHeading';
import { useLanguage } from '../../contexts/LanguageContext';

const BrandSlider = ({ data }) => {
  const { t } = useLanguage();
  const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
    <div {...props} className={'slick-arrow-left slick-arrow' + (currentSlide === 0 ? ' slick-disabled' : '')} aria-hidden="true" aria-disabled={currentSlide === 0 ? true : false}>
      <Icon icon="fa-solid:angle-left" />
    </div>
  );

  const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
    <div {...props} className={'slick-arrow-right slick-arrow' + (currentSlide === slideCount - 1 ? ' slick-disabled' : '')} aria-hidden="true" aria-disabled={currentSlide === slideCount - 1 ? true : false}>
      <Icon icon="fa-solid:angle-right" />
    </div>
  );

  const settings = {
    dots: false,
    infinite: false,
    loop: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    prevArrow: <SlickArrowLeft />,
    nextArrow: <SlickArrowRight />,
    responsive: [
      {
        breakpoint: 1599,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          dots: true
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          dots: true
        }
      }
    ]
  };

  return (
    <div className="st-gray-bg">
      <div className="st-height-b60 st-height-lg-b40" />
      <SectionHeading
        title={t('brands.title')}
        subTitle={t('brands.subtitle')}
      />
      <div className="container">
        {data.length === 1 ? (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              minHeight: '60px', // Matches st-height-b60 to prevent collapse
              padding: '20px 0', // Vertical padding for spacing
            }}
          >
            <div
              style={{
                textAlign: 'center',
                maxWidth: '250px', // Adjust based on your stretched logo size
                width: '100%',
              }}
            >
              <Brand {...data[0]} />
            </div>
          </div>
        ) : (
          <Slider {...settings} className="st-slider-style2">
            {data.map((elements, index) => (
              <Brand {...elements} key={index} />
            ))}
          </Slider>
        )}
      </div>
      <div className="st-height-b60 st-height-lg-b40" />
    </div>
  );
};

export default BrandSlider;